import React, {Component} from 'react';
import Const from 'constants';
import MultiSelect from 'components/atoms/dropdowns/multi-select';

class SelectStackingPosition extends Component {
    getOptions() {
        const {positions} = this.props;

        return positions.map((position) => {
            return {label: position, value: position};
        });
    }
    getSelectedValues(options) {
        return options.filter((option) => inArray(option.value, this.props.values)).map((option) => option);
    }
    render() {
        const options = this.getOptions();

        return (
            <MultiSelect
                key={Const.STACK_WITH_POSITION}
                onSelect={this.props.onChange}
                options={options}
                values={this.getSelectedValues(options)}
                placeholder={'Select multiple positions'}
            />
        );
    }
}

export default SelectStackingPosition;
